import { Component, Input, OnInit } from '@angular/core';
import {
    Session,
    SessionService,
    RegistrationDetailService,
} from '../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Account } from '../../../../../shared/model/account.model';
import { Principal } from '../../../../../shared/auth/principal.service';

@Component({
    selector: 'registration-booking',
    templateUrl: 'registration-booking.component.html',
    styleUrls: [
        '../registration.component.scss',
        '../../../../_shared/label/label.component.scss',
    ],
    providers: [],
})
export class RegistrationBookingComponent implements OnInit {
    @Input() companies: any;
    @Input() session: Session;
    @Input() trainingSession: any;
    @Input() users: any;
    @Input() usersNames: any[];
    futurEditingOption: any = {};
    currentEditingOptionId: number = -1;
    registrationOptions: any[] = [];
    unmodifiedRegistrationOptions: any[] = [];
    opcaStatusList: [string, string][] = [];
    opcaStatusMap: any = {};
    account: Account;

    isCurrentUserAdmin: boolean;
    currentEditingOption: any;
    private deleteModalRef;
    private leaveModalRef;

    constructor(
        private principal: Principal,
        private registrationDetailService: RegistrationDetailService,
        private sessionService: SessionService,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {
        this.getRegistrationOptions();
        this.initOPCAStatus();
        this.initAccount();
    }

    initAccount() {
        this.principal.identity().then((account) => {
            this.account = account;
            this.isCurrentUserAdmin =
                this.account.authorities.find((a) => a === 'ROLE_ADMIN') ===
                'ROLE_ADMIN';
        });
    }

    getTotalOptions(): string {
        let res = '';
        let totalOptions = 0;
        this.registrationOptions.forEach((option) => {
            totalOptions += option.nbStudents
                ? parseInt(option.nbStudents, 10)
                : 0;
        });

        if (totalOptions === 0) {
            res = 'Aucun stagiaire';
        } else if (totalOptions === 1) {
            res = '1 stagiaire';
        } else {
            res = totalOptions + ' stagiaires';
        }

        return res;
    }

    getCountRegistration(): number {
        return this.registrationDetailService.getCountRegistration(
            this.companies
        );
    }

    getRemainingPlaces(): string {
        let countOptions = 0;
        this.registrationOptions.forEach((option) => {
            countOptions += option.nbStudents
                ? parseInt(option.nbStudents, 10)
                : 0;
        });

        if (this.session.roomSize) {
            return (
                this.session.roomSize -
                this.getCountRegistration() -
                countOptions
            ).toString();
        }
        return '';
    }

    clickOnOption(option, leaveOptionModal): void {
        if (
            !option.id ||
            this.currentEditingOptionId === option.id ||
            option.id < 0
        ) {
            return;
        }
        if (this.isUserAllowedToEditOption(option) === true) {
            if (this.currentEditingOptionId == -1) {
                this.editOption(option);
            } else {
                this.futurEditingOption = option;
                this.showModalLeaveOption(leaveOptionModal);
            }
        }
    }

    updateSelectedOpcaStatus(option, newStatus): void {
        option.opcaStatus = newStatus;
    }

    saveOptionChanges(option): void {
        let optionToSave = Object.assign({}, option);
        optionToSave = this.updateOptionToBeSave(optionToSave);

        if (optionToSave.id) {
            this.sessionService
                .updateRegistrationOption(optionToSave)
                .subscribe((_) => {
                    this.unmodifiedRegistrationOptions =
                        this.registrationOptions.map((x) =>
                            Object.assign({}, x)
                        );
                    this.currentEditingOptionId = -1;
                });
        } else {
            this.sessionService
                .saveRegistrationOption(optionToSave)
                .subscribe((result) => {
                    option.id = result.id;
                    delete option.isNew;
                    this.unmodifiedRegistrationOptions =
                        this.registrationOptions.map((x) =>
                            Object.assign({}, x)
                        );
                    this.currentEditingOptionId = -1;
                    if (this.getCommercialIdByName(option.commercial) == -1) {
                        this.users.push({
                            id: result.commercialId,
                            email: this.account.email,
                            firstname: this.account.firstName,
                            lastname: this.account.lastName,
                        });
                    }
                });
        }
    }

    cancelEditOption(): void {
        this.registrationOptions = this.unmodifiedRegistrationOptions.map((x) =>
            Object.assign({}, x)
        );
        this.currentEditingOptionId = -1;
    }

    showModalDeleteOption(deleteModal) {
        event.stopPropagation();
        this.deleteModalRef = this.modalService.open(deleteModal);
    }

    addRegistrationOption(): void {
        if (this.currentEditingOptionId != -1) {
            return;
        }

        let tmpId = this.randomIntFromInterval(-2, -9999999);

        this.sessionService
            .getTrainingSessionById(this.session.id)
            .subscribe((trainingSession) => {
                this.trainingSession = trainingSession;
                this.registrationOptions.push({
                    id: tmpId,
                    deleted: false,
                    version: 1,
                    comments: '',
                    commercial:
                        this.account.firstName + ' ' + this.account.lastName,
                    commercialUser: this.account,
                    companyName: '',
                    commercialId: null,
                    contactInfo: '',
                    isNew: true,
                    nbStudents: 1,
                    trainingSession: trainingSession,
                    opcaStatus: 'NONE',
                    commercialEmail: this.account.email,
                    commercialFirstName: this.account.firstName,
                    commercialLastName: this.account.lastName,
                });
            });
        this.currentEditingOptionId = tmpId;
        this.currentEditingOption = {};
    }

    isAbleToSave(): boolean {
        if (this.isCurrentUserAdmin === true) {
            return true;
        } else if (this.currentEditingOption) {
            let remainingPlacesString = this.getRemainingPlaces();
            // this is not a session with a know room
            if (remainingPlacesString == '') {
                return true;
            }

            // we know how much places are available
            let remainingPlaces = parseInt(remainingPlacesString, 10);
            if (remainingPlaces < 0) {
                remainingPlaces = -1;
            }
            return (
                remainingPlaces >= 0 &&
                this.currentEditingOption.nbStudents !== 0
            );
        }
        return false;
    }

    editFuturOption(): void {
        this.currentEditingOption = this.futurEditingOption;
        this.currentEditingOptionId = this.futurEditingOption.id;
        this.closeLeaveModal();
    }

    closeLeaveModal() {
        this.leaveModalRef.close();
    }

    closeDeleteModal() {
        this.deleteModalRef.close();
    }

    deleteCurrentEditingOption(): void {
        this.closeDeleteModal();
        this.sessionService
            .deleteRegistrationOption(this.currentEditingOptionId)
            .subscribe();

        this.registrationOptions = this.registrationOptions.filter(
            (item) => item.id !== this.currentEditingOptionId
        );
        this.unmodifiedRegistrationOptions =
            this.unmodifiedRegistrationOptions.filter(
                (item) => item.id !== this.currentEditingOptionId
            );
        this.currentEditingOptionId = -1;
    }

    getCommercialIdByName(commercialName: string): number {
        let commercialUser = this.users.find(
            (u) => u.firstname + ' ' + u.lastname === commercialName
        );
        return commercialUser === undefined ? -1 : commercialUser.id;
    }

    isUserAllowedToEditOption(option: any): boolean {
        if (this.isCurrentUserAdmin) {
            return true;
        }
        if (!option.commercialUser || !this.account) {
            return false;
        }
        return option.commercialUser.email === this.account.email;
    }

    private initOPCAStatus(): void {
        this.opcaStatusList.push(['Aucun', 'NONE']);
        this.opcaStatusList.push(['En cours', 'IN_PROGRESS']);
        this.opcaStatusList.push(['Reçu', 'RECEIPT']);
        this.opcaStatusList.push(['Refusé', 'REFUSAL']);

        this.opcaStatusMap['NONE'] = 'Aucun';
        this.opcaStatusMap['IN_PROGRESS'] = 'En cours';
        this.opcaStatusMap['RECEIPT'] = 'Reçu';
        this.opcaStatusMap['REFUSAL'] = 'Refusé';
    }

    private editOption(option): void {
        this.currentEditingOption = option;
        this.currentEditingOptionId = option.id;
    }

    private randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    private showModalLeaveOption(leaveOptionModal) {
        event.stopPropagation();
        this.leaveModalRef = this.modalService.open(leaveOptionModal, {
            windowClass: 'center-modal',
        });
    }

    private updateOptionToBeSave(option: any): any {
        option.commercialId = this.getCommercialIdByName(option.commercial);

        option.opcaStatus = this.opcaStatusList.find(
            (e) => e[1] === option.opcaStatus
        )[1];
        if (option.isNew === true) {
            delete option.id;
            delete option.isNew;
        }

        return option;
    }

    private getRegistrationOptions() {
        this.sessionService
            .getRegistrationOptions(this.session.id)
            .subscribe((res) => {
                this.registrationOptions = res.sort(
                    (regA, regB) => regA.id - regB.id
                );
                this.registrationOptions.forEach((reg) => {
                    if (this.users) {
                        reg.commercialUser = this.users.find(
                            (user) => user.id === reg.commercialId
                        );
                        if (reg.commercialUser) {
                            reg.commercial =
                                reg.commercialUser.firstname +
                                ' ' +
                                reg.commercialUser.lastname;
                        }
                    }
                    if (!this.opcaStatusList) {
                        reg.opcaStatus = this.opcaStatusList.find(
                            (e) => e[1] === reg.opcaStatus
                        )[0];
                    }
                });
                this.unmodifiedRegistrationOptions =
                    this.registrationOptions.map((x) => Object.assign({}, x));
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-booking/registration-booking.component.ts